// extracted by css-extract-rspack-plugin
export default {"grammarErrorAlert__container":"grammarErrorAlert__container__R2pPi","grammarErrorAlert__title":"grammarErrorAlert__title__hMtzP"};